import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-27d154ac")

_pushScopeId("data-v-27d154ac")
const _hoisted_1 = { class: "esri-widget overlays" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx, _cache) => {
  const _component_OverlaysList = _resolveComponent("OverlaysList")
  const _component_OverlayEdition = _resolveComponent("OverlayEdition")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.mode === 'list')
      ? (_openBlock(), _createBlock(_component_OverlaysList, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.mode === 'overlay')
      ? (_openBlock(), _createBlock(_component_OverlayEdition, { key: 1 }))
      : _createCommentVNode("", true)
  ]))
})